export enum ActionPlanRoutePathsEnum {
  ACTION_PLAN = '/action-plan',
  GOAL_DETAIL = '/action-plan/:goalId',
}
